import React from "react"
import clsx from "clsx"
import Editor from "./Editor"
import PageChart from "./PageChart"
import PageWidget from "./PageWidget"
import ContentSelector from "./ContentSelector"
import PageBuilderActions from  "./actions/PageBuilderActions"
import PageBuilderConstants from "./constants/PageBuilderConstants"

class Column extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      contentType: this.props.contentType ? this.props.contentType : null
    };

    this.onDelete = this.onDelete.bind(this);
    this.onReset = this.onReset.bind(this);
    this.onContentSelection = this.onContentSelection.bind(this);
  }

  componentDidUpdate(nextProps) {
    if (nextProps.contentType !== this.state.contentType) {
      this.setState({contentType: nextProps.contentType})
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.contentType !== this.state.contentType) {
  //     this.setState({contentType: nextProps.contentType})
  //   }
  // }

  isActive() {
    return this.props.activeRowId === this.props.rowId && this.props.activeColumnId === this.props.id;
  }

  isDisabled() {
    return (!this.isActive() && this.props.activeColumnId !== null)
  }

  isResizing() {
    return this.props.rowId === this.props.resizeRowId;
  }

  render() {
    var deleteButtonClasses = clsx({
      'btn-sm btn-secondary delete-column': true,
      hidden: this.isActive() || this.props.mode !== PageBuilderConstants.COMPOSE,
      disabled: this.isResizing() || this.props.openMenuRowId !== null
    });

    var editButtonClasses = clsx({
      'btn-sm btn-secondary edit-column': true,
      hidden: this.isActive() || this.props.mode !== PageBuilderConstants.COMPOSE,
      disabled: this.isResizing() || this.props.openMenuRowId !== null
    });

    var columnClasses = clsx({
      column: true,
      disabled: this.isDisabled(),
      active: this.isActive(),
      resizing: this.isResizing(),
      highlight: this.props.highlightColumnId == this.props.id,
      'col-md-1': this.props.size == 1,
      'col-md-2': this.props.size == 2,
      'col-md-3': this.props.size == 3,
      'col-md-4': this.props.size == 4,
      'col-md-5': this.props.size == 5,
      'col-md-6': this.props.size == 6,
      'col-md-7': this.props.size == 7,
      'col-md-8': this.props.size == 8,
      'col-md-9': this.props.size == 9,
      'col-md-10': this.props.size == 10,
      'col-md-11': this.props.size == 11,
      'col-md-12': this.props.size == 12
    });

    // var props = {
    //   accommodations: this.props.accommodations,
    //   forms: this.props.forms,
    //   textVariables: this.props.textVariables,
    //   rowId: this.props.rowId,
    //   columnId: this.props.id,
    //   mode: this.props.mode,
    //   activeRowId: this.props.activeRowId,
    //   activeColumnId: this.props.activeColumnId,
    //   openMenuRowId: this.props.openMenuRowId,
    //   resizeRowId: this.props.resizeRowId,
    //   pageBuilderMounted: this.props.pageBuilderMounted,
    //   forceUpdate: this.props.forceUpdate
    // }

    return (
      <div className={columnClasses} id={this.props.id}>
        {this.props.mode === 'compose' ? <button className={deleteButtonClasses} onClick={this.onDelete} title={I18n.t('delete_column')}><span className="ss-trash"></span></button> : null }
        {this.state.contentType && this.props.mode === 'compose' ? <button className={editButtonClasses} onClick={this.onReset} title={I18n.t('reset_column')}><span className="ss-sync"></span></button> : null}
        {this.renderContentType()}
      </div>
    );
  }

  renderContentType() {
    if (this.state.contentType === 'text') {
      return (
        <div>
          <Editor {...this.props} ref="editor" initialContent={this.props.content} initialStyle={this.props.style} />
        </div>
      );
    } else if (this.state.contentType === 'chart') {
      return (
        <div className="ContentSelectorChart">
          <PageChart {...this.props} />
        </div>
      );
    } else if (this.state.contentType === 'widget') {
      return (
        <div className="ContentSelectorWidget">
          <PageWidget {...this.props} />
        </div>
      );
    } else {
      return (
        <ContentSelector {...this.props} onContentSelection={this.onContentSelection} />
      );
    }
  }

  // Change handlers

  onDelete(event) {
    event.preventDefault();
    event.stopPropagation();

    PageBuilderActions.deleteColumn(this.props.rowId, this.props.id);
  }

  onReset(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({contentType: null});
    PageBuilderActions.resetColumn(this.props.rowId, this.props.id);
  }

  onContentSelection(contentType) {
    this.setState({contentType: contentType}, () => {
      PageBuilderActions.setContentType(this.props.rowId, this.props.id, contentType);
    });
   
  }

  // Helper functions

  // shouldComponentUpdate() {
  //   if (this.props.resizeRowId !== null && this.props.resizeRowId !== this.props.rowId) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // }

};

export default Column
